import { REFI_PERSONAL_CONST } from '../shared/constants/app.constants.js';
import { ApiService } from '../core/services/api/api.service.js';

export class _TextOptInService {
  saveTextOptIn(phoneNumber, smsOptIn, phoneType) {
    const body = {};
    body[`${phoneType}PhoneNumber`] = phoneNumber.replace(/-/g, '');
    body[`has ${phoneType}TcpaConsent`.toCamelCase()] = smsOptIn;
    body.primaryPhoneType = phoneType.toUpperCase();
    const [, , profileRefId] = document?.cookie?.match(
      '(^|;) ?C1_PRID=([^;]*)(;|$)'
    ) || ['', '', ''];
    const headers = REFI_PERSONAL_CONST.HTTP_HEADERS;
    headers.profileReferenceId = profileRefId;
    return ApiService.post(
      REFI_PERSONAL_CONST.SAVE_CUSTOMER_CONTACT_URL,
      body,
      headers,
      REFI_PERSONAL_CONST.TIMEOUT_IN_MS
    );
  }
}

export const TextOptInService = new _TextOptInService();
